import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "changer" }
const _hoisted_2 = { class: "changer__icon-box" }
const _hoisted_3 = { class: "changer__current-month" }
const _hoisted_4 = { class: "changer__icon-box" }
const _hoisted_5 = ["title"]

import {computed, ref} from "vue";
import { useStore } from "vuex";
import { WTime, ShiftExistence } from '@/types';


const __default__ = {
  name: 'vita-month-changer'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()

const currentMouth = computed<string>(() => {
  return store.getters['getCurrentMoth']
})

const currentDate = computed<Date>(() => {
  return store.getters['getCurrentDate']
})

// Наличие смен и ФРВ в следующем месяце
const isShiftExistence = computed<ShiftExistence>(() => {
  return store.getters["data/shiftExistence"] && store.getters["data/shiftExistence"].frv;
});

const hasUnsavedChanges = computed(() => {
  return store.getters['hasUnsavedChanges']
})

const timeScheduleDetailsPast = computed<WTime[]>(() => {
  return store.getters['data/timeScheduleDetailsPast']
})

const savedPrevMonth = computed<null | string>(() => {
  return localStorage.getItem('activePrevMonth')
})

const savedNextMonth = computed<null | string>(() => {
  return localStorage.getItem('activeNextMonth')
})

const currentMonthNumber: number = new Date().getMonth();

const isActivePrev = computed<boolean>(() => {
  const currentDateMonth: number = currentDate.value.getMonth();
  // Вычисляем предыдущий месяц для корректного перехода между годами
  const prevMonth = (currentMonthNumber - 1 + 12) % 12;
  return prevMonth !== currentDateMonth;
});

const isActiveNext = computed<boolean>(() => {
  const currentDateMonth: number = currentDate.value.getMonth();
  // Вычисляем следующий месяц для корректного перехода между годами
  const nextMonth = (currentMonthNumber + 1) % 12;
  return nextMonth !== currentDateMonth;
});

const indexMoth = ref<number>(0)

const saveSelectedMonth = () => {
  if (!isActiveNext.value) {
    localStorage.setItem("activeNextMonth", '1')
  } else if (!isActivePrev.value) {
    localStorage.setItem("activePrevMonth", '1')
  } else {
    localStorage.removeItem("activeNextMonth")
    localStorage.removeItem("activePrevMonth")
  }
}

const prevMouth = async (index: number) => {
  if (hasUnsavedChanges.value) {
    // Если выполняется переход на другую аптеку и добавлен новый внешний сотрудник - запрашиваем подтверждение
    const leaveConfirm = window.confirm('Есть несохраненные изменения на графике, перейти на другой месяц?')

    if (leaveConfirm) {
      store.commit('setUnsavedChanges', false)
    } else {
      return false
    }
  }

  store.commit('user/setLoader', true)
  indexMoth.value += index
  store.commit('setMoth', index)
  store.commit('data/removeOldShift')
  store.commit('setDate', currentDate.value)
  store.commit('data/clearOpenedCreateShift')
  await store.dispatch("data/getExternalUsers");
  await store.dispatch('data/getFondWorkTime')
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getShiftsExistence");
  await store.dispatch("data/getTimeScheduleDetails");
  await store.dispatch("data/getPastTimeScheduleDetails");
  await store.dispatch('data/getTimeSchedule')
  await store.dispatch('data/getPharmSchedule')
  await store.dispatch('data/getAdminShift', true);
  await store.dispatch('data/getFondWorkTimeHuman')
  saveSelectedMonth()
  store.commit('user/setLoader', false)
}

const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

// Проверка на наличие "more" или "less" в любом дне следующего месяца
const containsDayFullMoreOrLess = (obj: object) => {
  for (const date in obj) {
    if (obj[date].dayFull === 'more' || obj[date].dayFull === 'less') {
      return true
    }
  }
  return false
}

const hasUnfilledDays = () => {
  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return undefined
  }

  if (isShiftExistence.value && containsDayFullMoreOrLess(timeScheduleDetailsPast.value)) {
    return 'Необходимо исправить время в следующем месяце'
  }
  return undefined
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isActivePrev.value && indexMoth.value !== -1 && !savedPrevMonth.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "selector selector-prev",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (prevMouth(-1))),
            "data-qa": "month-changer-selector-prev"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(currentMouth.value), 1),
    _createElementVNode("div", _hoisted_4, [
      (isActiveNext.value && indexMoth.value !== 1 && !savedNextMonth.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["selector selector-next", {'selector-blinking' : hasUnfilledDays()}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (prevMouth(1))),
            title: hasUnfilledDays(),
            "data-qa": "month-changer-selector-next"
          }, null, 10, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})